<template lang="pug">
  aside.aside
    nav.menu(v-if="links.length")
      ul.lista
        li.item(v-for="(link, id) of links")
          router-link.link(v-if="link.rota", :to="{ name: link.rota }") {{ link.texto }}
          a.link(v-else-if="link.url", :href="link.url" target="_blank" noopener) {{ link.texto }}
</template>

<style lang="scss">
  .aside {
    background-color: $color-grey-dark;
    min-height: inherit !important;
    height: 100%;

    > .menu {

      > .lista {
        position: relative;

        > .item > .link {
          display: block;
          color: inherit;
          padding: 15px 30px;
          text-transform: uppercase;
          @extend %font_bold;

          &:before {
            content: "\f0da"; /* FontAwesome Unicode */
            font-family: FontAwesome;
            display: inline-block;
            margin-left: -1.3em; /* same as padding-left set on li */
            width: 1.3em; /* same as padding-left set on li */
          }

        }
      }

    }
  }
</style>

<script>
  export default {
    props: {
      links: { type: Array, required: true }
    }
  }
</script>



// WEBPACK FOOTER //
// HotsiteAside.vue?bd142942